export enum ExchangeRateCommissionType {
    Percentage = 1,
    Money = 2,
}
